import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StudentLeftside from "./StudentLeftside";
import Swal from "sweetalert2";
import API_BASE_URL from "../config/api";

export default function PasswordChange() {

  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const API_URL = `${API_BASE_URL}/change_password.php`;

  const validate = () => {
    if (!newPass.trim()) {
      Swal.fire("Required", "Please enter new password", "warning");
      return false;
    }
    if (newPass.length < 8) {
      Swal.fire("Weak Password", "Password must be at least 8 characters", "warning");
      return false;
    }
    if (confirmPass !== newPass) {
      Swal.fire("Mismatch", "Confirm password does not match", "error");
      return false;
    }
    return true;
  };

  const logoutAndRedirect = () => {
    sessionStorage.removeItem("user");
    setTimeout(() => navigate("/login"), 1200);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const storedUser = (() => {
      try {
        return JSON.parse(sessionStorage.getItem("user") || "{}");
      } catch {
        return {};
      }
    })();

    const userId = storedUser?.id ?? storedUser?.userid ?? storedUser?.userId;
    if (!userId) {
      Swal.fire("Not Logged In", "Please login again", "warning");
      return navigate("/login");
    }

    setLoading(true);

    try {
      const fd = new FormData();
      fd.append("userid", userId);
      fd.append("new_password", newPass);

      const res = await fetch(API_URL, { method: "POST", body: fd });
      const text = await res.text();
      const data = JSON.parse(text);

      if (!data.success) throw new Error(data.message || "Password update failed");

      Swal.fire({
        icon: "success",
        title: "Password Changed!",
        text: "Logging out...",
        timer: 1400,
        showConfirmButton: false,
      });

      setNewPass("");
      setConfirmPass("");

      logoutAndRedirect();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    }

    setLoading(false);
  };

  return (
    <div className="dashboard-wrap bg-light">
      <StudentLeftside />

      <div className="dashboard-content pt-5">
  
         <div className="justify-content-between align-items-center mb-3 pt-8">
          <h3 className="mb-4">Change Password</h3>

        <div className="dashboard-widg-bar d-block">

          <div className="card">

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">

                  <div className="col-xl-6 col-md-12">
                    <div className="form-group">
                      <label>New Password</label>
                      <input
                        type="password"
                        className="form-control"
                        value={newPass}
                        min={8}
                        max={8}
                        onChange={(e) => setNewPass(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-12">
                    <div className="form-group">
                      <label>Confirm Password</label>
                      <input
                        type="password"
                        className="form-control"
                         min={8}
                         max={8}
                        value={confirmPass}
                        onChange={(e) => setConfirmPass(e.target.value)}
                      />
                    </div>
                  </div>

                </div>

                {/* ✔ RIGHT ALIGNED SAVE BUTTON */}
                <div className="mt-3 text-end">
                  <button
                    type="submit"
                    className="btn ft--medium btn-main px-5"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save Password"}
                  </button>
                </div>

              </form>
            </div>
          </div>

        </div>
          </div>
      </div>
    </div>
  );
}
